"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Box_1 = require("./Box");
const TrendingIcon = (props) => {
    const svgStyle = Object.assign({ "position": "absolute", "top": "0", "right": "0", "bottom": "0", "left": "0", "width": "100%", "height": "100%" });
    return (React.createElement(Box_1.Box, Object.assign({ position: "relative", width: 18, height: 18 }, props),
        React.createElement("svg", { viewBox: "0 0 18 18", style: svgStyle, fill: "currentColor" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.6162 5L12.5 5V4H15.5H16.5V5V8H15.5V5.88393L9.94199 11.4419C9.69791 11.686 9.30218 11.686 9.05811 11.4419L6.50005 8.88388L2.44199 12.9419L1.55811 12.0581L6.05811 7.55806C6.30218 7.31398 6.69791 7.31398 6.94199 7.55806L9.50005 10.1161L14.6162 5Z" }))));
};
TrendingIcon.displayName = 'TrendingIcon';
exports.default = TrendingIcon;
//# sourceMappingURL=TrendingIcon.js.map